// import React from 'react';
// import './AboutUs.css';

// const AboutUs = () => {
//   return (
//     <div className="about-us">
//       <section className="intro">
//         <h1>About LogicBunny</h1>
//         <p>
//           Founded in July 2020, LogicBunny Technology Private Ltd is a dynamic and innovative technology company based in Bangalore, Karnataka. We specialize in developing cutting-edge Rummy games and comprehensive software solutions, committed to delivering excellence and innovation.
//         </p>
//       </section>

//       <section className="mission">
//         <h2>Our Mission</h2>
//         <p>
//           At LogicBunny, our mission is to push the boundaries of technology to create impactful and engaging solutions. We strive to offer superior Rummy gaming experiences and tailor-made software solutions that meet the unique needs of our clients and set new industry standards.
//         </p>
//       </section>

//       <section className="expertise">
//         <h2>Our Expertise</h2>
//         <div className="expertise-grid">
//           <div className="expertise-item">
//             <h3>Rummy Game Development</h3>
//             <p>
//               We craft immersive Rummy games using advanced algorithms and real-time technology to ensure smooth and fair gameplay. Our games are designed to be engaging and adaptable to various platforms.
//             </p>
//           </div>
//           <div className="expertise-item">
//             <h3>Custom Software Solutions</h3>
//             <p>
//               From custom software development to cloud-based solutions, we provide a wide range of services to help businesses achieve their goals. Our solutions are designed to be scalable and tailored to your specific requirements.
//             </p>
//           </div>
//           <div className="expertise-item">
//             <h3>Innovation & Technology</h3>
//             <p>
//               Our team stays ahead of the curve by continuously exploring new technologies and methodologies. We are committed to integrating the latest innovations to deliver cutting-edge solutions.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="why-choose-us">
//         <h2>Why Choose Us?</h2>
//         <ul>
//           <li>Expertise in creating high-quality Rummy games with robust anti-cheating mechanisms.</li>
//           <li>Custom software solutions tailored to your business needs.</li>
//           <li>Commitment to continuous innovation and staying ahead of industry trends.</li>
//           <li>Dedicated team of professionals with a passion for technology and excellence.</li>
//         </ul>
//       </section>

//       <section className="join-us">
//         <h2>Join Us</h2>
//         <p>
//           We invite you to be a part of our journey to revolutionize the tech industry. Whether you are a prospective client, partner, or future team member, let’s collaborate to make a difference and achieve great things together.
//         </p>
//       </section>
//     </div>
//   );
// }

// export default AboutUs;


import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      {/* Introduction */}
      <section className="intro">
        <h1>Welcome to LogicBunny Technology</h1>
        <p>
          Established in July 2020, LogicBunny Technology Private Ltd is a Bangalore-based tech company 
          specializing in high-quality Rummy game development and software solutions. We blend creativity 
          with technology to build products that captivate and drive business success.
        </p>
      </section>

      {/* Mission Statement */}
      <section className="mission">
        <h2>Our Mission</h2>
        <p>
          Our mission is to redefine gaming and software innovation by creating seamless and engaging experiences. 
          Whether it's an advanced Rummy game or a tailored business solution, we are committed to delivering 
          unparalleled quality, reliability, and security.
        </p>
      </section>

      {/* Expertise Section */}
      <section className="expertise">
        <h2>Our Expertise</h2>
        <div className="expertise-grid">
          <div className="expertise-item">
            <h3>🎮 Rummy Game Development</h3>
            <p>
              We craft immersive Rummy experiences with real-time gameplay, AI-driven fairness, and cross-platform support. 
              Our games offer high-performance, engaging animations, and robust security.
            </p>
          </div>
          <div className="expertise-item">
            <h3>💡 Custom Software Solutions</h3>
            <p>
              Our expertise extends beyond gaming—we build scalable software for businesses. 
              From web applications to enterprise solutions, we design software tailored to your needs.
            </p>
          </div>
          <div className="expertise-item">
            <h3>🚀 Innovation & Technology</h3>
            <p>
              We leverage the latest in AI, cloud computing, and cybersecurity to push the boundaries of digital transformation.
              Our team continuously explores new advancements to stay ahead of industry trends.
            </p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <h2>Why Choose LogicBunny?</h2>
        <ul>
          <li>✅ Industry-leading Rummy game development with anti-cheating mechanisms.</li>
          <li>✅ Tailor-made software solutions designed for scalability and efficiency.</li>
          <li>✅ Proven track record in delivering high-performance applications.</li>
          <li>✅ Passionate team of experts committed to technological excellence.</li>
        </ul>
      </section>

      {/* Call to Action */}
      <section className="join-us">
        <h2>Join Us on Our Journey</h2>
        <p>
          Whether you're a business looking for a cutting-edge solution or a talented professional seeking 
          new opportunities, we welcome you to be a part of our success story.
        </p>
        <p className="contact-info">
          📩 Reach out at <a href="mailto:info@logicbunny.com">info@logicbunny.com</a> or explore our <a href="/careers">Career Opportunities</a>.
        </p>
      </section>
    </div>
  );
}

export default AboutUs;
